/**
 * MedModuleNotes — бележки от общия списък „лекарства, добавки и билки",
 * подбрани за конкретния модул (гърда, черен дроб, лаборатории, ум и тяло).
 * Данни: GET /api/medications/module-insights
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Pill, AlertTriangle, Activity, Info, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SEV = {
  high: { color: "#EF4444", label: "ВАЖНО", Icon: AlertTriangle },
  watch: { color: "#F59E0B", label: "НАБЛЮДЕНИЕ", Icon: Activity },
  info: { color: "#0EA5E9", label: "ЗА ЗНАНИЕ", Icon: Info },
};

const TITLES = {
  bhi: "Вашите лекарства и добавки за гърдата",
  liver: "Вашите лекарства и добавки за черния дроб",
  labs: "Как лекарствата Ви влияят на изследванията",
  mind: "Вашите лекарства и добавки за съня и настроението",
};

export default function MedModuleNotes({ module, cardCls, isDark }) {
  const [notes, setNotes] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/medications/module-insights`)
      .then(({ data }) => setNotes(data?.groups?.[module] || []))
      .catch(() => setNotes([]));
  }, [module]);

  if (!notes?.length) return null;

  const base = cardCls || (isDark
    ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200");

  return (
    <div className={`p-4 rounded-2xl border ${base}`} data-testid={`med-module-notes-${module}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h3 className="text-sm font-bold flex items-center gap-2">
          <Pill className="w-4 h-4 text-violet-500" />
          {TITLES[module] || "Вашите лекарства и добавки"}
        </h3>
        <button onClick={() => navigate("/dashboard/medications")}
          className="text-[10px] font-semibold opacity-60 hover:opacity-100 inline-flex items-center gap-1"
          data-testid={`med-module-notes-open-${module}`}>
          целият списък <ArrowRight className="w-3 h-3" />
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {notes.map((n, idx) => {
          const s = SEV[n.severity] || SEV.info;
          return (
            <div key={`${n.title_bg}-${idx}`} className="rounded-xl p-2.5"
              style={{ background: s.color + "12", borderLeft: `3px solid ${s.color}` }}
              data-testid={`med-module-note-${module}-${idx}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="text-[12px] font-bold">{n.title_bg}</span>
                <span className="text-[9px] font-bold px-1.5 py-0.5 rounded inline-flex items-center gap-1"
                  style={{ background: s.color + "22", color: s.color }}>
                  <s.Icon className="w-3 h-3" /> {s.label}
                </span>
              </div>
              <div className="text-[12px] mt-1 opacity-90">{n.text_bg}</div>
              <div className="text-[10px] mt-1 opacity-55">от списъка Ви: {n.med_bg}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
